import { Stack } from "@mui/material";
import { MainDetails } from "../contractDetails/mainDetails";
import { PaymentDetails } from "../contractDetails/paymentDetails";
import { IContractProps } from "../models";

export const ContractDetails = ({ contract }: IContractProps) => {
  return (
    <Stack spacing={3} width={"100%"}>
      <MainDetails contract={contract} />
      <PaymentDetails contract={contract} />
    </Stack>
  );
};
